import Profile from './Profile';
export default Profile;



// WEBPACK FOOTER //
// ./src/components/profile/index.js